






























import {Vue, Component, Prop, Watch} from 'vue-property-decorator'

@Component({})
export default class NumericStepper extends Vue {
  @Prop () private value: number = 1
  @Prop () private min: number = 1
  @Prop ({ default: Infinity }) private max!: number
  @Prop () private step: number = 1
  @Prop ({default: false}) private previousDisabled!: boolean
  @Prop ({default: false}) private nextDisabled!: boolean

  private stepperValue: number = this.value
  private stepperMax: number = this.max

  @Watch('value')
  private valueWatcher(newVal: number) {
    this.stepperValue = newVal
  }

  @Watch('max')
  private maxWatcher(newVal: number) {
    this.stepperMax = newVal
  }

  private increase() {
    const newVal = (this.stepperMax !== undefined && this.stepperMax !== Infinity) ?
        Math.min(Number(this.stepperValue) + this.step, this.stepperMax) :
        Number(this.stepperValue) + this.step
    this.$emit('input', newVal)
  }

  private decrease() {
    const newVal = Math.max(this.stepperValue - this.step, this.min)
    this.$emit('input', newVal)
  }

  private stepperChanged(event: any) {
    const inputValue = parseFloat(event.target.value)
    if (inputValue > this.stepperMax) {
      this.stepperValue = this.stepperMax
      event.target.value = this.stepperMax
    }
    if (inputValue < this.min) {
      this.stepperValue = this.min
      event.target.value = this.min
    }
    this.$emit('input', this.stepperValue)
  }
}
